export type SupportedLanguage = 'hr' | 'sr' | 'bs' | 'sl' | 'de' | 'en'

export const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['hr', 'sr', 'bs', 'sl', 'de', 'en']

export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
	hr: 'Hrvatski',
	sr: 'Srpski',
	bs: 'Bosanski',
	sl: 'Slovenščina',
	de: 'Deutsch',
	en: 'English'
}

export const LANGUAGE_FLAGS: Record<SupportedLanguage, string> = {
	hr: '🇭🇷',
	sr: '🇷🇸',
	bs: '🇧🇦',
	sl: '🇸🇮',
	de: '🇩🇪',
	en: '🇬🇧'
}

export const DEFAULT_LANGUAGE: SupportedLanguage = 'hr'

export const isValidLanguage = (lang: string): lang is SupportedLanguage => {
	return SUPPORTED_LANGUAGES.includes(lang as SupportedLanguage)
}

export type PaymentTier = 'basic' | 'premium' | 'exclusive'
export type PaymentLanguage = 'hr' | 'de' | 'en'
